import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from './cn';
import { RequiredMark } from './RequiredMark';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** 필수 입력/선택 필드 마커(빨강 `*`)를 라벨 텍스트 우측에 노출 (ID56). */
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        'text-sm font-medium text-[color:var(--content-strong)]',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...props}
    >
      {children}
      {required && <RequiredMark />}
    </label>
  ),
);
Label.displayName = 'Label';
